import React, { useState } from 'react';
import { connect } from 'react-redux';
import AlertBox, { Heading } from 'components/shared/AlertBox';
import * as sessionActions from 'actions/inPersonTraining/eventOverview/sessions';
import { toggleTrainerChangeConfirmation } from 'actions/inPersonTraining/eventOverview/eventChangeManagement';
import { Button, ButtonGroup } from 'ui';
import LinkButton from 'components/shared/LinkButton';
import { useToggle } from 'components/shared/hooks';

const TrainerChangeConfirmation = ({
  updateSession,
  onDismiss,
  sessionChanges,
}) => {
  const [loading, setLoading] = useState(false);
  const [sendEmails, toggleSendEmails] = useToggle(false);

  const handleConfirm = () => {
    setLoading(true);
    updateSession(sessionChanges, {
      trainer_change_confirmed: true,
      send_update_to_participants: sendEmails,
    });
  };

  return (
    <AlertBox onDismiss={loading ? () => {} : onDismiss}>
      <Heading>
        {t(
          'in_person_training.event_overview.trainer_change_confirmation.heading',
        )}
      </Heading>
      <div
        dangerouslySetInnerHTML={{
          __html: t(
            'in_person_training.event_overview.trainer_change_confirmation.body',
          ),
        }}
      />
      <label className="mt-8" htmlFor="send_update_to_participants">
        <input
          type="checkbox"
          id="send_update_to_participants"
          checked={sendEmails}
          onChange={toggleSendEmails}
        />
        <span className="ml-8">
          {t(
            'in_person_training.event_overview.trainer_change_confirmation.notify_attendants',
          )}
        </span>
      </label>
      <ButtonGroup alignEnd>
        <LinkButton
          type="primary"
          className="mr-8"
          disabled={loading}
          onClick={onDismiss}
        >
          {t('common.cancel')}
        </LinkButton>
        <Button customColor loading={loading} onClick={handleConfirm}>
          {t(
            'in_person_training.event_overview.trainer_change_confirmation.change_instructor',
          )}
        </Button>
      </ButtonGroup>
    </AlertBox>
  );
};

const mapStateToProps = ({ eventChangeManagement }) => ({
  sessionChanges: eventChangeManagement.trainerChange.session,
});

const mapDispatchToProps = {
  updateSession: sessionActions.updateSession,
  onDismiss: toggleTrainerChangeConfirmation,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TrainerChangeConfirmation);
